import { Component } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { CmSettingsService, PortalCoreFeature } from '@ats/cm/core';

@Component({
    selector: 'cm-unsaved-confirmation',
    templateUrl: './cm-unsaved-confirmation.component.html',
    styleUrls: ['./cm-unsaved-confirmation.component.scss'],
    standalone: false
})
export class CmUnsavedConfirmationComponent {
	readonly locFeature: PortalCoreFeature;

	constructor(public dialogRef: MatDialogRef<CmUnsavedConfirmationComponent>, private settings: CmSettingsService) {
		this.locFeature = this.settings.portalCoreFeature;
	}

	onNoClick(): void {
		this.dialogRef.close(false);
	}
}
